export default __webpack_public_path__ + "static/media/tf-icon.5701c489.webp";